import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../pages/Home.css";



const AREAS = [
  "Koramangala",
  "HSR Layout",
  "Electronic City",
  "Whitefield",
  "Mahadevapura",
  "Jayanagar",
  "Rajajinagar",
  "Malleswaram",
  "Marathahalli",
  "JP Nagar",
  "Banashankari",
  "KR Puram",
  "Vijayanagar",
  "BTM Layout",
];

const ISSUES = [
  "Washing Machine Repair",
  "Refrigerator Repair",
  "Microwave Repair",
  "AC Repair",
  "Dishwasher Repair",
];

const BRANDS = ["LG", "Samsung", "IFB", "Whirlpool", "Bosch"];

const ServiceShowcase = () => {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? AREAS : AREAS.slice(0, 12);

  return (
    <section className="service-showcase">
      {/* LEFT */}
      <div className="showcase-left">
        <span className="eyebrow">Bengaluru Coverage</span>

        <h2>
          Doorstep pickup & delivery across{" "}
          <span className="glow-accent">45+ neighbourhoods</span>
        </h2>

        <p className="showcase-lead">
          We reach most pockets within 45 minutes. All visits include free
          diagnostics and sealed job sheets.
        </p>

        {/* AREAS */}
        <div className="chip-cloud">
          {visible.map((area) => (
            <Link
              key={area}
              to={`/appliance-repair-service-in-${area.toLowerCase().replace(/\s+/g, "-")}`}
              className="chip-pill"
            >
              {area}
            </Link>
          ))}
        </div>

        {/* BUTTON */}
        <button className="ghost-btn" onClick={() => setShowAll(!showAll)}>
          {showAll ? "Show less" : `See all ${AREAS.length} pockets`}
        </button>
      </div>

      {/* RIGHT */}
      <div className="showcase-right">
        {/* SERVICES CARD */}
        <div className="stack-card">
          <div className="stack-card-head">
            <span className="eyebrow">Common Appliance Issues</span>
            <span className="pill-note">MOST DONE SAME-DAY</span>
          </div>

          <div className="pill-grid">
            {ISSUES.map((item) => (
              <span key={item} className="issue-pill">
                {item}
              </span>
            ))}
          </div>
        </div>

        {/* BRANDS CARD */}
        <div className="stack-card">
          <div className="stack-card-head">
            <span className="eyebrow">Brands We Fix</span>
            <span className="pill-note soft">OEM PARTS + WARRANTY</span>
          </div>

          <div className="brand-pill-row">
            {BRANDS.map((brand) => (
              <span key={brand} className="brand-pill">
                {brand}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceShowcase;
